import React, { FC } from "react";

const BannerLoaderImage: FC<{ loaderIcon: string }> = ({ loaderIcon }) => (
  <div className="loader-wrapper">
    <img src={loaderIcon} alt="loader-icon" className="loader-icon" />
  </div>
);

export default BannerLoaderImage;
